import script from "./TableGenerator.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableGenerator.vue?vue&type=script&lang=ts&setup=true"

import "./TableGenerator.vue?vue&type=style&index=0&id=668111ab&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-668111ab"]])

export default __exports__